module.exports = __webpack_public_path__ + "img/england.79ca6b34.svg";